import { environment } from '../environments/environment';

export class Granule {
  // CMS Global variable

  CMS_Version = 'L5.4 v0.1';
  CMS_ROUTE_SERVER = environment.CMS_ROUTE_SERVER + '/api';
  CMS_ROUTE_URI = '/benvuneto';

  CMS_BASE_HREF = environment.CMS_BASE_HREF;
  CMS_ROUTE_API = this.CMS_ROUTE_SERVER;
  CMS_ROUTE_STORAGE_TICKET = environment.CMS_ROUTE_SERVER +
    '/storage/ticketing';
  CMS_ROUTE_STORAGE_USER = environment.CMS_ROUTE_SERVER +
    '/storage/profilepictures';

  YEAR_OF_DEVELOPMENT = '2017';
  SHOW_CMS_VERSION = true;
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/config.ts